import { FC } from 'react'
import { MdModeEdit } from 'react-icons/md'

import DropdownMenuItem from '../../../atoms/DropdownMenuItem'
import { usePageHeaderDashboardMenuContext } from '../PageHeaderDashboardMenuProvider'

const RenameDashboardMenu: FC = () => {
  const { setModalOpened } = usePageHeaderDashboardMenuContext()
  return (
    <DropdownMenuItem
      icon={<MdModeEdit className="text-hit-gray" />}
      label="Rename"
      data-testid="header-dashboard-menu-rename"
      onClick={() => setModalOpened('rename')}
    />
  )
}

export default RenameDashboardMenu
